import React from 'react';

import type { CreateDialogContextType } from './create-dialog-context-types';
import { getDefaultContextState } from './defaults';

export const CreateDialogContext =
	React.createContext<CreateDialogContextType>(getDefaultContextState());

CreateDialogContext.displayName = 'CreateDialogContext';
